// General Enums
export var MathOperation;
(function (MathOperation) {
    MathOperation["Add"] = "Add";
    MathOperation["Subtract"] = "Subtract";
    MathOperation["Multiply"] = "Multiply";
    MathOperation["Divide"] = "Divide";
})(MathOperation || (MathOperation = {}));
// Enums used in Strategies
export var ExportDestination;
(function (ExportDestination) {
    ExportDestination["Excel"] = "Excel";
    ExportDestination["CSV"] = "CSV";
    ExportDestination["Clipboard"] = "Clipboard";
    ExportDestination["JSON"] = "JSON";
    ExportDestination["Table"] = "Table";
})(ExportDestination || (ExportDestination = {}));
export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["Report"] = "Report";
    ScheduleType["ipushpull"] = "ipushpull";
    ScheduleType["Reminder"] = "Reminder";
    ScheduleType["OpenFin"] = "OpenFin";
})(ScheduleType || (ScheduleType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "Asc";
    SortOrder["Desc"] = "Desc";
})(SortOrder || (SortOrder = {}));
export var SelectionMode;
(function (SelectionMode) {
    SelectionMode["Multi"] = "Multi";
    SelectionMode["Single"] = "Single";
})(SelectionMode || (SelectionMode = {}));
export var FontWeight;
(function (FontWeight) {
    FontWeight["Normal"] = "Normal";
    FontWeight["Bold"] = "Bold";
})(FontWeight || (FontWeight = {}));
export var FontStyle;
(function (FontStyle) {
    FontStyle["Normal"] = "Normal";
    FontStyle["Italic"] = "Italic";
})(FontStyle || (FontStyle = {}));
export var FontSize;
(function (FontSize) {
    //  Default = 'Default',
    FontSize["XSmall"] = "XSmall";
    FontSize["Small"] = "Small";
    FontSize["Medium"] = "Medium";
    FontSize["Large"] = "Large";
    FontSize["XLarge"] = "XLarge";
})(FontSize || (FontSize = {}));
export var ColumnMenuTab;
(function (ColumnMenuTab) {
    ColumnMenuTab["Menu"] = "Menu";
    ColumnMenuTab["Filter"] = "Filter";
})(ColumnMenuTab || (ColumnMenuTab = {}));
export var StatusColour;
(function (StatusColour) {
    StatusColour["Error"] = "var(--ab-color-error)";
    StatusColour["Warn"] = "var(--ab-color-warn)";
    StatusColour["Success"] = "var(--ab-color-success)";
    StatusColour["Info"] = "var(--ab-color-info)";
})(StatusColour || (StatusColour = {}));
export var SummaryOperation;
(function (SummaryOperation) {
    SummaryOperation["Sum"] = "Sum";
    SummaryOperation["Average"] = "Average";
    SummaryOperation["Median"] = "Median";
    SummaryOperation["Mode"] = "Mode";
    SummaryOperation["Distinct"] = "Distinct";
    SummaryOperation["Max"] = "Max";
    SummaryOperation["Min"] = "Min";
    SummaryOperation["Count"] = "Count";
    SummaryOperation["Std_Deviation"] = "Std Deviation";
    SummaryOperation["Only"] = "Only";
    SummaryOperation["Weighted_Average"] = "Weighted Avg";
})(SummaryOperation || (SummaryOperation = {}));
export var FilterOnDataChangeOptions;
(function (FilterOnDataChangeOptions) {
    FilterOnDataChangeOptions["Always"] = "Always";
    FilterOnDataChangeOptions["Never"] = "Never";
    FilterOnDataChangeOptions["Throttle"] = "Throttle";
})(FilterOnDataChangeOptions || (FilterOnDataChangeOptions = {}));
export var ChangeDirection;
(function (ChangeDirection) {
    ChangeDirection["Up"] = "Up";
    ChangeDirection["Down"] = "Down";
    ChangeDirection["Neutral"] = "Neutral";
})(ChangeDirection || (ChangeDirection = {}));
